import { useI18nStore } from "../stores/i18n";
import { storeToRefs } from "pinia";

/**
 * Convenience composable for templates:
 *   const { t, ta, locale, setLocale } = useI18n();
 *   {{ t('nav.quotes') }}
 *   {{ t('quotes.quotaUsed', { used: 2, limit: 2 }) }}
 */
export function useI18n() {
  const store = useI18nStore();
  const { locale } = storeToRefs(store);
  return {
    t: store.t,
    ta: store.ta,
    locale,
    setLocale: store.setLocale,
    isFrench: store.isFrench,
    isEnglish: store.isEnglish,
  };
}
